import React from "react";
import { Link } from "react-router-dom";

const AccessDenied = () => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="text-center p-4">
        <h1 className="display-4 text-danger">403</h1>
        <h3 className="mb-3">Access Denied</h3>
        <p className="text-muted mb-4">
          You don’t have permission to access this page.
        </p>

        <Link to="/dashboard" className="btn btn-primary">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default AccessDenied;
